import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/imgs/support/main.png';
import _imports_1 from '@/assets/imgs/support/key.png';
import _imports_2 from '@/assets/imgs/support/lock.png';
import _imports_3 from '@/assets/imgs/support/view.png';
import _imports_4 from '@/assets/imgs/support/data.png';
import _imports_5 from '@/assets/imgs/support/use.png';
const _withScopeId = n => (_pushScopeId("data-v-58446345"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "home"
};
const _hoisted_2 = {
  class: "wrap wrap-top"
};
const _hoisted_3 = {
  class: "top"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "left"
}, [/*#__PURE__*/_createElementVNode("img", {
  alt: "",
  src: _imports_0
})], -1));
const _hoisted_5 = {
  class: "right"
};
const _hoisted_6 = {
  class: "wrap wrap-why"
};
const _hoisted_7 = ["src"];
const _hoisted_8 = {
  class: "wrap wrap-manager"
};
const _hoisted_9 = {
  class: "manager"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "left"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
})], -1));
const _hoisted_11 = {
  class: "right"
};
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1));
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: ""
}, null, -1));
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: ""
}, null, -1));
const _hoisted_15 = {
  class: "wrap wrap-key"
};
const _hoisted_16 = {
  class: "zone"
};
const _hoisted_17 = {
  class: "left"
};
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "right"
}, [/*#__PURE__*/_createElementVNode("img", {
  alt: "",
  src: _imports_5
})], -1));
import { onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import Download from '@/components/Download.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'Support',
  setup(__props) {
    const {
      t
    } = useI18n();
    onMounted(() => {
      document.documentElement.scrollTop = 0;
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", _hoisted_5, [_createElementVNode("h1", null, _toDisplayString(_unref(t)('support.top.title')), 1), _createElementVNode("p", null, _toDisplayString(_unref(t)('support.top.desc')), 1), _createVNode(Download)])])]), _createElementVNode("div", _hoisted_6, [_createElementVNode("h1", null, _toDisplayString(_unref(t)('support.why.title')), 1), _createElementVNode("ul", null, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, i => {
        return _createElementVNode("li", null, [_createElementVNode("img", {
          src: require(`@/assets/imgs/support/${i - 1}.png`),
          alt: ""
        }, null, 8, _hoisted_7), _createElementVNode("h3", null, _toDisplayString(_unref(t)(`support.why.list[${i - 1}].title`)), 1), _createElementVNode("p", null, _toDisplayString(_unref(t)(`support.why.list[${i - 1}].desc`)), 1)]);
      }), 64))])]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_hoisted_10, _createElementVNode("h1", null, _toDisplayString(_unref(t)('support.manager.title')), 1), _createElementVNode("div", _hoisted_11, [_createElementVNode("h3", null, [_hoisted_12, _createTextVNode(" " + _toDisplayString(_unref(t)('support.manager.info[0]')), 1)]), _createElementVNode("h3", null, [_hoisted_13, _createTextVNode(" " + _toDisplayString(_unref(t)('support.manager.info[1]')), 1)]), _createElementVNode("h3", null, [_hoisted_14, _createTextVNode(" " + _toDisplayString(_unref(t)('support.manager.info[2]')), 1)])])])]), _createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [_createElementVNode("h1", null, _toDisplayString(_unref(t)('support.use.title')), 1), _createElementVNode("p", null, _toDisplayString(_unref(t)('support.use.desc')), 1), _createVNode(Download)]), _hoisted_18])])]);
    };
  }
});